<template>
    <div class="main-content container">

        <message-box :is-show="showMessage"></message-box>

        <loading-spinner :is-show="showLoadingToLoadingProp"></loading-spinner>

        <header-div 
            v-on:showLoading="handleShowLoading" 
            v-on:logoutclick="handleLogoutClick"
            :needToLogin="needToLogin" 
            :userName="userName" >
        </header-div>

        <login-popup 
            v-on:afterLogin="handleAfterLogin" 
            v-on:showLoading="handleShowLoading"
            :is-show="needToLogin"
            :layout-hub="layout" >
        </login-popup>

        <div id="appContainer">
            <main-content 
                v-on:showLoading="handleShowLoading" 
                v-on:showErrorMessage="handleShowErrorMessage">
            </main-content>
        </div>
    </div>
</template>

<script>
    import headerDiv from './header.vue'
    import loadingSpinner from './loadingSpinner.vue'
    import loginPopup from './loginPopup.vue'
    import mainContent from './mainContent.vue'
    import messageBox from './messageBox.vue'
    import axios from '../services/axiosClient'
    import * as config from '../services/config'

    export default {
        components:{
            headerDiv,
            loadingSpinner,
            loginPopup,
            mainContent,
            messageBox
        },
        data: function() {
            return {
                showLoadingToLoadingProp: true,
                needToLogin: false,
                showMessage: false,
                logoutClick: false,
                userName: '',
                layout: 'darkness'
            }
        },
        async created() {

            var self = this;
            var authPromise = await axios.get('/api/Auth/IsAuthenticated');
                var result = authPromise.data;

                self.needToLogin = ! result.IsUserAuthenticated;
                self.userName = result.UserName;
                self.layout = result.Layout;
        },
        methods: {
            handleShowLoading: function(payload) {
                console.log('handleShowLoading', payload);
                this.showLoadingToLoadingProp = payload;
            },
            handleAfterLogin: function(payload) {
                this.userName = payload.userInfo.UserName;
                this.needToLogin = payload.userInfo.isLogin
            },
            handleShowErrorMessage: function(payload) {
                this.showMessage = payload;
            },
            handleLogoutClick: function() {
                this.logoutClick = true;
            },
            readCookie:function(name) {
                    var nameEQ = name + "=";
                    var ca = document.cookie.split(';');
                    for (var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                        if (c.indexOf(nameEQ) == 0) {
                            return c.substring(nameEQ.length, c.length);
                        }
                    }
                    return null;
            },
            checkSession: function() {
                    if (!this.needToLogin && !this.logoutClick) {
                        this.showMessage = true;
                        this.logout();
                    }
                },
            checkLogout: function() {

                var self = this;

                var interval = setInterval(function() {
                    if (self.readCookie("SMIHub") == null) {
                        clearInterval(interval);
                        self.checkSession();
                    }
                }, 500);
            },
            logout: function() {
                var url = config.rootURL + '/api/Auth/Logout'; //'?v=' + v;
                try{
                    var logoutPromise = axios.get(url);
                    //location.reload();

                }catch(err){
                    console.log('err',err);
                }
            }
        },
        mounted: function() {
            if (!this.needToLogin) {
                this.checkLogout();
            }
        },
        watch: {
            needToLogin: function(newVal) {
                if (!newVal) {
                    this.checkLogout();
                }
            }
        }
    }
</script>